import React, { useEffect, useState } from 'react';
import '../../../CSS/TablaHerramientas.css'
import { getPermission } from '../../../Conexiones/Conexion';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from "react-router";
import { FaArrowLeftLong } from 'react-icons/fa6';
import { deleteApi, getApi, postApi, putApi } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Loading from '../../../Utils/Loading';

function TablaUnidad() {
    const navigate = useNavigate();
    const [unidades,setUnidades]=useState([]);
    const [tablaUnidad,setTablaUnidad]=useState([]);
    const [busqueda,setBusqueda] = useState ('');
    const [nombre,setNombre]=useState('');
    const [idUnidad,setIdUnidad] = useState ('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'unidad/';
    const [isSaving, setSaving] = useState(false);
    const [isLoading,setIsLoading]=useState(false);

    useEffect (()=>{
        const getUnidades = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,9);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setUnidades(res.data)
                        setTablaUnidad(res.data)
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getUnidades();
    },[idUsuario,navigate]);

    const getUnidades = async () =>{
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setUnidades(res.data)
                setTablaUnidad(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = tablaUnidad.filter((elemento)=> {
            if (elemento.nombreUnidad.toString().toLowerCase().includes(textoIngresado.toLowerCase())){
                return elemento;
            }
            return resultadoBusqueda
        });
        setUnidades(resultadoBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos')
    }

    const modalEliminar = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTA UNIDAD?')
        .then(async (result)  => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="registro eliminado"){
                        getUnidades();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const store = async (e) =>{
        setSaving(true)
        e.preventDefault()
        if(nombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri;
            const data = {nombreUnidad:nombre};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleClose();
                    getUnidades();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }

    //Editar
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (id,nombre) =>{
        setNombre(nombre);
        setIdUnidad(id);
        setShowEdit(true);
    }

    const update= async (e) => {
        e.preventDefault()
        if(nombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri + idUnidad;
            const data = {nombreUnidad:nombre};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="Registro modificado"){
                    handleCloseEdit();
                    getUnidades();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
    }
    
    return (
        <div className="tablaHerramientas">
            {
                isLoading ?
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">gestión de unidades</label>
                    </div>  
                    <div className='divboton' >                                                                                             
                        <div className='boton' style={{display:'flex', justifyContent:'space-between'}}>
                            <button  className="btn btn-light btncolor" onClick={handleShow}  type="button">
                                <label className="agregar">UNIDAD</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input type="search"  value={busqueda} onChange={buscar}  placeholder="Buscar"  className="form-control" style={{width:'50%'}} aria-describedby="basic-addon1"/> 
                        </div>
                    </div>
                    {
                        unidades.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA">
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered text-uppercase">
                                        <thead className="encabezado">
                                            <tr>
                                                <th > UNIDAD </th>
                                                <th style={{width:'50%'}}>ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                        { unidades.map( u => {
                                            return (
                                                <tr key={u.idUnidad}>
                                                    <td valign="middle">{u.nombreUnidad}</td>
                                                    <td>
                                                        <div>
                                                            <div className="btn iconoH" onClick={() => handleShowEdit(u.idUnidad,u.nombreUnidad)} style={{margin:'5px'}}>
                                                                <span className="bi bi-pen" title="EDITAR"></span>
                                                            </div>
                                                            <div className="btn iconoH" style={{margin:'5px'}} onClick={() => modalEliminar(u.idUnidad)}>
                                                                    <span className="bi bi-trash" title="ELIMINAR"></span>
                                                            </div>                                     
                                                        </div>
                                                    </td>
                                                </tr>
                                            )})
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }
                    
                    {/*AGREGAR UNIDAD*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-unidad">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR UNIDAD</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombre(e.target.value) }/>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR UNIDAD*/}
                    <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-unidad">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR UNIDAD</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label" style={{color:'black'}}>NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" value={nombre} 
                                    onChange={(e) => setNombre(e.target.value) }  required/>
                                </div> 
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default TablaUnidad;
